export default {
      id: "icon--leisure-legday-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--leisure-legday-usage",
      toString: function () {
        return this.url;
      }
    }